import "./EventDetailPage.css";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import DefaultPage from "../DefaultPage/DefaultPage";
import Introduction from "../../components/Introduction";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import Loader from "../../components/Loader";
import DynamicZoneBuilder from "../../components/DynamicZoneBuilder.js";

const EventDetailPage = () => {
  // parametry ktere dostavame z url adresy (id)
  const params = useParams();
  const { id } = params;

  //fetch udalosti
  const { loading, error, data } = useFetch(
    // `${config.api}/api/events/${id}?populate=*`
    `${config.api}/api/events/${id}?populate[content][on][bloky.images][populate]=*&populate[content][on][bloky.text][populate]=*&populate[content][on][bloky.files][populate][files][populate]=*`
  );
  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání událostí" />;

  //? test
  //? console.log("udalosti", data);

  //kontrola jestli fetch pro dane id plati -> jinak default page s hlaskou nenalezeno
  if (!data || !data.data) return <DefaultPage message="Projekt nenalezen" />;

  //změna titulku stránky v prohlížeči
  document.title = data.data.name;

  return (
    <div className="min-height-100 d-flex flex-column">
      <Navbar />
      <Introduction title={data.data.name} text="" />
      <div className="container container-background d-flex flex-column gap-4 p-5">
        <DynamicZoneBuilder components={data?.data?.content} />
      </div>
      <Footer />
    </div>
  );
};
export default EventDetailPage;
